import { defineStore } from "pinia";
export const useAppWideStore = defineStore("appWide", {
  state: () => ({
    applicationName: "Tennis Lineup",
  }),
});
